/**
 * Warenkorb + Alle Warenkorb-Artikel (wird bei checkCart befüllt)
 */
let MYCART = {};

/**
 * Das aktuelle Produkt
 */
let myProduct = {};

/**
 * Loading.Gif
 */
let ajax_loader_gif = '';

/**
 * Aktueller Collection-Handle
 * @type {string}
 */
let myCollectionHandle = '';

/**
 * Bild des Künstlers selbst
 */
let artistImgUrl = "";

/**
 * Beschreibung des Künstlers
 */
let artistDesc = "";

/**
 * Globals
 */
let meGlobals = {
    "TESTSYSTEM": {
        "CHECKURL": "pco-test-crunchysnacks\.myshopify\.com",
        "SYSTEMURL": "https://dev-shopify-app-crunchysnacks.pco-group.com"
    },
    "LIVESYSTEM": {
        "CHECKURL": "crunchysnacks\.de",
        "SYSTEMURL": "https://shopify-app-crunchysnacks.pco-group.com"
    }
};

/**
 * Produkte
 * @type Object
 */
let productDetails = {};

/**
 * Artists (Künstler)
 * @type {{}}
 */
let artistDetails = {};

/**
 * Artworks (Kunstwerke)
 * @type {{}}
 */
let artworkDetails = {};

/**
 * Signaturen (Unterschriften der Künstler)
 * @type {{}}
 */
let signatureDetails = {};

/**
 * ME-Customizer: Field Selectors
 * @type {string}
 */
let mecustomizer_fieldselector_product = '.product-variants #selector_product #product';
let mecustomizer_fieldselector_size = '.product-variants #product-select-product-template-customizable-option-0';
let mecustomizer_fieldselector_color = '.product-variants #product-select-product-template-customizable-option-1';
let mecustomizer_fieldselector_artwork = '.product-variants #selector_kunstwerk #kunstwerk_property';
let mecustomizer_fieldselector_artwork_hidden = '.product-variants #selector_kunstwerk #kunstwerk_hidden_property';
let mecustomizer_fieldselector_print = '.product-variants #selector_bedrucken #bedrucken_property';
let mecustomizer_fieldselector_print_hidden = '.product-variants #selector_bedrucken #bedrucken_hidden_property';
let mecustomizer_canvas = 'meCustomizer1MyCanvas1';
let mecustomizer_produktbildcontainer_selector = '#meCustomizer1 .produktbildcontainer';

/**
 * Link zum derzeitigen Produkt-Bild
 * @type {string}
 */
let currentProductImage = '';

/**
 * Produkt öffnen
 */
function openProduct(typ, artwork)
{
    window.location.href = '/products/' + typ + '?artwork=' + artwork;
}

/**
 * Pfand - Default-Values (werden in theme.liquid überschrieben)
 */
let PFAND_CART_CHECK = false;
let PFAND_ARTIKEL_25 = {};
let PFAND_KOSTEN_ARTIKEL_25 = {};

/**
 * Bonus-Artikel - Default-Values (werden in theme.liquid überschrieben)
 */
let BONUS_CART_CHECK = false;
let free_bonus_item_products = {};
let productIdGlasses = null;
let productIdSocks = null;
let myProductId = null;
let hasVariants = null;
let currentVariantID = null;

/**
 * Discount Gutschein bei 50€
 */
let DISCOUNT_CART_CHECK = false;

/**
 * Product_ID der Gutscheine
 * @type {number}
 */
let DISCOUNT_GUTSCHEIN_PRODUCT_ID = 6550472884363;

/**
 * Variant_ID des Artikels, der hinzugefügt werden soll
 * @type {number}
 */
let DISCOUNT_VARIANT_ID = 39294051025035;


/**
 * Array for doUrlRedirect
 * @type {[{from: string, to: string}, {from: string, to: string}]}
 */
let urlredirects = [
    {
        "from": "/products/moreno_buffalo-color",
        "to": "/products/me-t-shirt-1?size=Erwachsene%20:%20S&color=grau&artwork=moreno_buffalo-color&print=Vorderseite"
    }
];

/**
 * Wird bei Submit von CArtform aufgerufen
 * @param event
 */
function checkBusy(event)
{
    console.log(jQuery('#ajaxBusy').is(':visible'));
    if (jQuery('#ajaxBusy').is(':visible') === true)
    {
        event.preventDefault();
    }
}

/**
 *
 * @param id
 */
function cartEntfernenButton(id)
{
    jQuery.ajax({
        url: '/cart/change.js',
        method: 'POST',
        data: {
            quantity: 0,
            id: id
        },
        dataType: 'json',
        success: function (ret)
        {
            console.log(ret);
            checkCart();
            ajaxLoadCart();
            stopCartLoading();
        },
        error: function ()
        {
            console.log('entfernenButton: Ajax Error');
            stopCartLoading();
        }
    });

}

/**
 * Allgemeine Routine zum Prüfen des Warenkorbs
 *
 * Routine wird im Javascript-Event-Handler vom Shopify-Theme 'script.js' Zeile 2165 aufgerufen.
 *
 * @param {boolean} doSiteReload
 * @return {boolean}
 */
function checkCart(doSiteReload = false)
{
    // Buttons deaktivieren / Loading starten
    startCartLoading();

    // Aktuellen Warenkorb abholen
    getCurrentCart();

    if (
        (typeof MYCART === 'undefined') ||
        (typeof MYCART['items'] === 'undefined') ||
        MeMisc.empty(MYCART) === true ||
        MeMisc.empty(MYCART['items']) === true
    )
    {
        stopCartLoading();
        return MYCART;
    }

    /**
     * Pfand 25 Cent
     * Prüfen ob sich was an den Pfand-Artikeln geändert hat
     */
    if (
        (typeof PFAND_CART_CHECK !== 'undefined') &&
        (typeof PFAND_ARTIKEL_25 !== 'undefined') &&
        (typeof PFAND_KOSTEN_ARTIKEL_25 !== 'undefined') &&
        (typeof PFAND_KOSTEN_ARTIKEL_25['id'] !== 'undefined') &&
        (typeof PFAND_KOSTEN_ARTIKEL_25['variants'] !== 'undefined') &&
        (typeof PFAND_KOSTEN_ARTIKEL_25['variants'][0] !== 'undefined') &&
        (typeof PFAND_KOSTEN_ARTIKEL_25['variants'][0]['id'] !== 'undefined') &&
        PFAND_CART_CHECK === true &&
        MeMisc.empty(PFAND_ARTIKEL_25) === false &&
        MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25) === false &&
        MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25['id']) === false &&
        MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25['variants'][0]['id']) === false
    )
    {
        // Pfand-Artikel mit Ajax abrufen, weil mit {{ collections["pfand-artikel-25"].products | json }} nur maximal 50 Datensätze abgeholt werden!
        getPfand25ollectionProducts();

        // Vars
        let PFAND_KOSTEN_ARTIKEL_25_variant_id = PFAND_KOSTEN_ARTIKEL_25['variants'][0]['id'];
        let pfand25Changed = false;
        let anzcpka25 = 0;

        // Pfand-Artikel - die sich im Warenkorb befinden - holen
        let PfandArtikelInCart = getPfandArtikelInCart(PFAND_ARTIKEL_25, MYCART['items']);

        // Pfand-Kosten-Artikel holen
        let cpka25item = getCartItemByProductid(PFAND_KOSTEN_ARTIKEL_25['id'], MYCART['items']);

        // prüfen ob Artikel mehrmals vorhanden
        // Wenn PFAND_KOSTEN_ARTIKEL_25 mehrmals im Cart ist, dann alle PFAND_KOSTEN_ARTIKEL_25-Artikel löschen und neu aufbauen
        if (MeMisc.empty(cpka25item) === false)
        {
            jQuery.each(MYCART['items'], function (cidx, citem)
            {
                // counter hochzählen
                if (MeMisc.empty(citem['product_id']) === false && (citem['product_id'] === PFAND_KOSTEN_ARTIKEL_25['id']))
                    anzcpka25++;
            });
        }
        if (anzcpka25 > 1)
            pfand25Changed = true;

        let totalqnty = 0;

        jQuery.each(PfandArtikelInCart, function (pidx, pitem)
        {
            totalqnty = totalqnty + pitem['quantity'];
        });

        if (MeMisc.empty(cpka25item) === false)
        {
            if (cpka25item['quantity'] !== totalqnty)
                pfand25Changed = true;
        }

        // Prüfen ob Pfand-Kosten-Artikel die Pfand-Artikel als Properties hinterlegt hat.
        if (checkPfand(cpka25item, PfandArtikelInCart) === true)
            pfand25Changed = true;

        // prüfen ob Pfandkosten vorhanden aber kein Pfandartikel
        if (MeMisc.empty(PfandArtikelInCart) === true && MeMisc.empty(cpka25item) === false)
            pfand25Changed = true;

        // Ajax-Requests (delete/add)
        if (pfand25Changed === true)
        {
            // Pfand-Kosten-Artikel löschen
            if (MeMisc.empty(cpka25item) === false && MeMisc.empty(cpka25item['key']) === false)
            {
                jQuery.ajax({
                    url: '/cart/change.js',
                    method: 'POST',
                    data: {
                        quantity: 0,
                        id: cpka25item['key']
                    },
                    dataType: 'json',
                    success: function (result, textStatus, jqXHR)
                    {
                    },
                    error: function (jqXHR, textStatus)
                    {
                    },
                    async: false
                });

                ajaxLoadCart();
            }

            // Pfand-Kosten-Artikel hinzufügen anhand der Pfand-Artikel
            let PFAND_KOSTEN_ARTIKEL_25_quantity = 0;
            let PFAND_ERROR = null;
            let PFAND_SUCCESS = null;
            let PFAND_KOSTEN_ARTIKEL_25_properties = {};
            PFAND_KOSTEN_ARTIKEL_25_properties['_products'] = [];

            jQuery.each(PfandArtikelInCart, function (pa_variantid, pa_item)
            {
                PFAND_KOSTEN_ARTIKEL_25_quantity += pa_item['quantity'];
                PFAND_KOSTEN_ARTIKEL_25_properties['_products'].push({
                    'quantity': pa_item['quantity'],
                    'sku': pa_item['sku'],
                    'variant_id': pa_item['variant_id']
                });
            });

            if (MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25_variant_id) === false && PFAND_KOSTEN_ARTIKEL_25_quantity > 0 && MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25_properties) === false)
            {
                jQuery.ajax({
                    url: '/cart/add.js',
                    method: 'POST',
                    data: {
                        quantity: PFAND_KOSTEN_ARTIKEL_25_quantity,
                        id: PFAND_KOSTEN_ARTIKEL_25_variant_id,
                        properties: PFAND_KOSTEN_ARTIKEL_25_properties
                    },
                    dataType: 'json',
                    success: function (result, textStatus, jqXHR)
                    {
                        PFAND_SUCCESS = true;
                    },
                    error: function (jqXHR, textStatus)
                    {
                        PFAND_ERROR = true;
                    },
                    async: false
                });
            }

            // Aktuellen Warenkorb abholen
            getCurrentCart();

            // Warenkorb über Ajax neu laden
            ajaxLoadCart();
        }
    }

    // Aktuellen Warenkorb abholen
    getCurrentCart();

    if (
        (typeof MYCART === 'undefined') ||
        (typeof MYCART['items'] === 'undefined') ||
        MeMisc.empty(MYCART) === true ||
        MeMisc.empty(MYCART['items']) === true
    )
    {
        stopCartLoading();
        return MYCART;
    }

    /**
     * Bonus-Artikel:
     * Prüfen: Wenn über 29 Euro:
     * - Bonus-Artikel im WK vorhanden:
     */
    if (
        (typeof BONUS_CART_CHECK !== 'undefined') &&
        (typeof free_bonus_item_products !== 'undefined') &&
        BONUS_CART_CHECK === true &&
        MeMisc.empty(free_bonus_item_products) === false
    )
    {
        let cartitem_bonus = getBonusitemInCart(MYCART['items']);
        let cart_total_price = parseInt(MYCART['total_price']);
        cart_total_price = cart_total_price / 100;

        let totalPriceOhneGutschein2 = 0;
        let totalPriceOhneGutschein3;
        jQuery.each(MYCART['items'], function (abc, citem)
        {
            if (citem['gift_card'] !== true)
            {
                totalPriceOhneGutschein2 = totalPriceOhneGutschein2 + citem['final_line_price'];
            }
        });
        totalPriceOhneGutschein3 = totalPriceOhneGutschein2 / 100;

        let gte29 = checkPriceforBonusArtikel(totalPriceOhneGutschein3, MYCART['items']);

        if (gte29 === true && MeMisc.empty(cartitem_bonus) === false)
        {
            // Anzahl prüfen, wenn nicht 1 dann
            if (parseInt(cartitem_bonus['quantity']) !== 1)
            {
                jQuery.ajax({
                    url: '/cart/change.js',
                    method: 'POST',
                    data: {
                        quantity: 1,
                        id: cartitem_bonus['key']
                    },
                    dataType: 'json',
                    success: function (result, textStatus, jqXHR)
                    {
                    },
                    error: function (jqXHR, textStatus)
                    {
                    },
                    async: false
                });

                // Warenkorb über Ajax neu laden
                ajaxLoadCart();
            }
        }
        else if (gte29 === true && MeMisc.empty(cartitem_bonus) === true)
        {
            // ignorieren, Auswahl-Popup wurde bei checkPriceforBonusArtikel() geöffnet
        }
        else if (gte29 === false && MeMisc.empty(cartitem_bonus) === false)
        {
            jQuery.ajax({
                url: '/cart/change.js',
                method: 'POST',
                data: {
                    quantity: 0,
                    id: cartitem_bonus['key']
                },
                dataType: 'json',
                success: function (result, textStatus, jqXHR)
                {
                },
                error: function (jqXHR, textStatus)
                {
                },
                async: false
            });

            // Warenkorb über Ajax neu laden
            ajaxLoadCart();
        }
    }

    // Aktuellen Warenkorb abholen
    getCurrentCart();

    /**
     * DISCOUNT: Bei Einkauf ab 50€ 10€-Gutschein gratis
     * Gutschein automatisch hinzufügen
     */
    let cart_total_price = parseInt(MYCART['total_price']);
    cart_total_price = cart_total_price / 100;

    discount_fifty(cart_total_price, MYCART['items']);

    // Buttons aktivieren / Loading beenden
    stopCartLoading();

    // Handler jedesmal neu erstellen, weil Handler bei Add/Remove von Shopify-Routinen entfernt werden! :-(
    /*
    jQuery('.cart-table .item-row .item-qty').on('change', function ()
    {
        checkCart();
    });
    jQuery('.cart-table .item-row .qtybtn').on('click', function ()
    {
        checkCart();
    });
    */

    // Aktuellen Warenkorb abholen
    return getCurrentCart();
}

/**
 * Pfand-Artikel im Warenkorb durchsgehen und Prüfen ob Pfand-Kosten-Artikel diese Pfand-Artikel als Properties hinterlegt hat.
 *
 * @param {Object} pfand_kosten_artikel
 * @param {Object} pfand_artikel_in_cart
 * @return boolean : true = WK muss bearbeitet werden, false = WK ist in Ordnung
 */
function checkPfand(pfand_kosten_artikel, pfand_artikel_in_cart)
{
    let pfand25Changed = false;
    let cpka25item = pfand_kosten_artikel;

    // Prüfen ob sich was an den Pfand-Artikeln geändert hat
    jQuery.each(pfand_artikel_in_cart, function (cidx, citem)
    {
        // Pfand-Kosten-Artikel oder Property nicht vorhanden
        if (MeMisc.isset(cpka25item) === false || MeMisc.isset(cpka25item['properties']) === false || MeMisc.isset(cpka25item['properties']['_products']) === false)
        {
            pfand25Changed = true;
        }

        // Variantid in den Properties suchen
        // Pfand-Kosten-Artikel vorhanden, aber Menge stimmt nicht
        if (pfand25Changed === false)
        {
            let pknotavailable = true;
            jQuery.each(cpka25item['properties']['_products'], function (ccidx, ccproperty)
            {
                if (MeMisc.empty(ccproperty['variant_id']) === true || MeMisc.empty(ccproperty['quantity']) === true)
                {
                    pfand25Changed = true;
                    return false;
                }
                // Prüfen ob Artikel in Pfandkosten-Properties vorhanden
                if (ccproperty['variant_id'].toString() === citem['variant_id'].toString())
                {
                    pknotavailable = false;
                }
                // Prüfen ob Menge in Pfandkosten-Properties richtig ist
                if (ccproperty['variant_id'].toString() === citem['variant_id'].toString() && parseInt(ccproperty['quantity']) !== parseInt(citem['quantity']))
                {
                    pfand25Changed = true;
                    return false;
                }
            });

            if (pknotavailable === true)
            {
                pfand25Changed = true;
            }
        }
    });

    return pfand25Changed;
}

/**
 * Alle Pfand-Artikel die im Warenkorb sind als Object-Collection zurückgeben
 * @param {Object} all_pfand_artikel
 * @param {Object} cartItems
 * @return {Object} : Key: Variantid / Value: Quantity
 */
function getPfandArtikelInCart(all_pfand_artikel, cartItems = null)
{
    if (cartItems === null)
        cartItems = MYCART['items'];

    let pfandArtikelCollection = [];

    // Prüfen ob sich was an den Pfand-Artikeln geändert hat
    jQuery.each(cartItems, function (cidx, citem)
    {
        jQuery.each(all_pfand_artikel, function (pidx, pitem)
        {
            if (MeMisc.empty(citem['product_id']) === true || MeMisc.empty(pitem['id']) === true || MeMisc.empty(pitem['tags']) === true)
                return true;

            // product zu cartitem suchen / Pfand-Tag filtern
            if (citem['product_id'] === pitem['id'] && jQuery.isArray(pitem['tags']) && jQuery.inArray('Pfand', pitem['tags']) !== -1)
            {
                // Alle Pfand-Artikel speichern (später werden Pfandksoten gelöscht und neu hinzugefügt)
                pfandArtikelCollection.push(citem);
            }
        });
    });

    return pfandArtikelCollection;
}

/**
 * Buttons aus und Loading start
 */
function startCartLoading()
{
    jQuery('#cartform').on('submit', function (evt)
    {
        evt.preventDefault();
        return false;
    });
    // document.getElementById('cartform').addEventListener("submit", preventformsent);

    Array.from(document.getElementsByClassName("btn")).forEach(function (element)
    {
        if ((typeof element.defaultValue !== 'undefined') && element.defaultValue === "Bezahlen" && (typeof element.disabled !== 'undefined'))
        {
            element.disabled = true;
        }
    });

    let busycart = document.getElementById("ajaxBusyCart");
    if (busycart !== null && (typeof busycart.style !== 'undefined') && (typeof busycart.style.display !== 'undefined'))
        busycart.style.display = "block";
}

/**
 * Buttons an und Loading stop
 */
function stopCartLoading()
{
    jQuery('#cartform').off('submit');
    // document.getElementById('cartform').removeEventListener("submit", preventformsent);

    Array.from(document.getElementsByClassName("btn")).forEach(function (element)
    {
        if ((typeof element.defaultValue !== 'undefined') && element.defaultValue === "Bezahlen" && (typeof element.disabled !== 'undefined'))
        {
            element.disabled = false
        }
    });

    let busycart = document.getElementById("ajaxBusyCart");
    if (busycart !== null && (typeof busycart.style !== 'undefined') && (typeof busycart.style.display !== 'undefined'))
        busycart.style.display = "none";
}

/**
 *
 * @param evt
 * @returns {boolean}
 */
function preventformsent(evt)
{
    // Eingaben nicht korrekt
    evt.preventDefault();
    return false;
}

/**
 * Product im WK anhand der Variantid zurückgeben
 */
function getCartItemByVariantid(variantid, cartItems = null)
{
    if (cartItems === null)
        cartItems = MYCART['items'];

    // Pfand-Kosten-Artikel holen
    let myitem = null;
    jQuery.each(cartItems, function (cidx, citem)
    {
        // PFAND_KOSTEN_ARTIKEL_25 suchen
        if (MeMisc.empty(citem['variant_id']) === false && (parseInt(citem['variant_id']) === parseInt(variantid)))
        {
            myitem = citem;
        }
    });

    return myitem;
}

/**
 * Product im WK anhand der Productid zurückgeben
 */
function getCartItemByProductid(productid, cartItems = null)
{
    if (cartItems === null)
        cartItems = MYCART['items'];

    // Pfand-Kosten-Artikel holen
    let myitem = null;
    jQuery.each(cartItems, function (cidx, citem)
    {
        // PFAND_KOSTEN_ARTIKEL_25 suchen
        if (MeMisc.empty(citem['product_id']) === false && (parseInt(citem['product_id']) === parseInt(productid)))
        {
            myitem = citem;
        }
    });

    return myitem;
}

/**
 * Holt alle Produkte der Collection "Pfand-Artikel-25" ohne Datensatz-Limit
 */
function getPfand25ollectionProducts()
{
    jQuery.ajax({
        url: '/collections/pfand-artikel-25/products.json?limit=1000',
        method: 'GET',
        dataType: 'json',
        success: function (result)
        {
            if (!MeMisc.empty(result) && (typeof result['products'] !== 'undefined') && !MeMisc.empty(result['products']))
            {
                PFAND_ARTIKEL_25 = result['products'];
            }
        },
        error: function ()
        {

        },
        async: false
    });

    return PFAND_ARTIKEL_25;
}

/**
 * Aktuellen Warenkorb über Ajax abrufen und in MYCART speichern
 */
function getCurrentCart()
{
    // aktuellen Warenkorb abholen
    jQuery.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'json',
        success: function (result)
        {
            if (MeMisc.empty(result) === false)
            {
                MYCART = result;
            }
            else
            {
                MYCART = {};
            }
        },
        error: function ()
        {
            MYCART = {};
        },
        async: false
    });

    return MYCART;
}

/**
 * Preis vom Warenkorb prüfen. Wenn über 29 Euro, dann Popup anzeigen.
 *
 * @param cart_total_price
 * @param cartItems
 * @return boolean : true cart-price >= 29, false cart-price < 29
 */
function checkPriceforBonusArtikel(cart_total_price, cartItems)
{
    let modal = jQuery('#bonus-modal-id-xx');
    cart_total_price = parseFloat(cart_total_price);

    if (BONUS_CART_CHECK === true && cart_total_price >= 29.00 && jQuery.isArray(cartItems) === true && jQuery.isArray(free_bonus_item_products) === true)
    {
        let bonusItemExist = false;
        let bonusItem = getBonusitemInCart(cartItems);

        if (bonusItem !== null)
            bonusItemExist = true;

        if (bonusItemExist === false)
            if (Cookies.get('sawBonus') !== 'true')
            {
                jQuery(modal).show();
            }
        return true;
    }
    else
    {
        jQuery(modal).hide()
        return false;
    }
}

/**
 * BonusItem im Cart suchen und productid zurückgeben
 *
 * @param {Array} cartItems
 * @return null|Object
 */
function getBonusitemInCart(cartItems)
{
    if (jQuery.isArray(cartItems) === false || jQuery.isArray(free_bonus_item_products) === false)
        return null;

    let mycartitem = null;
    jQuery.each(cartItems, function (cidx, cartitem)
    {
        jQuery.each(free_bonus_item_products, function (pidx, product)
        {
            if (parseInt(cartitem['product_id']) === parseInt(product['id']))
            {
                mycartitem = cartitem;
            }
        });
    });

    return mycartitem;
}

/**
 * checkPrice
 */
function checkPrice()
{
    if (MeMisc.empty(MYCART['items']) === true)
        return false;

    let mycartItems = MYCART['items'];
    let totalPrice = parseInt(MYCART['total_price']);

    totalPrice = totalPrice / 100;

    let totalPriceOhneGutschein = 0;
    jQuery.each(mycartItems, function (cindex, citem)
    {
        if (citem['gift_card'] !== true)
        {
            totalPriceOhneGutschein = totalPriceOhneGutschein + citem['final_line_price'];
        }
    });
    totalPriceOhneGutschein = totalPriceOhneGutschein / 100;

    checkPriceforBonusArtikel(totalPriceOhneGutschein, mycartItems);
}

/**
 * Funktion für den 10€ Gutschein ab einem Einkaufswert von 50€
 */
function discount_fifty(total_price, cartItems)
{
    if (DISCOUNT_CART_CHECK === true)
    {
        let cart_price = parseFloat(total_price);
        let discountitem = getDiscountitemInCart(cartItems);

        cart_price = cart_price - getGutscheinPriceInCart(cartItems) - getPfandKostenInCart(cartItems);

        if (cart_price >= 50 && jQuery.isArray(cartItems) === true && MeMisc.empty(discountitem) === true && typeof discountitem !== "undefined")
        {
            jQuery.ajax({
                url: "/cart/add.js",
                method: 'POST',
                data: {
                    items: [{
                        quantity: 1,
                        id: DISCOUNT_VARIANT_ID,
                        properties: {
                            "_byME": "true"
                        }
                    }],
                },
                dataType: 'json',
                success: function (result, textStatus, jqXHR)
                {
                },
                error: function (jqXHR, textStatus)
                {
                },
                async: false
            });
        }
        else if (MeMisc.empty(discountitem) !== true && typeof discountitem !== "undefined")
        {
            if (cart_price < 50 && MeMisc.empty(discountitem.properties) !== true && typeof discountitem.properties !== "undefined")
            {
                if (discountitem.properties._byME === "true" && typeof discountitem.properties._byME !== "undefined")
                {
                    let q = discountitem.quantity - 1;

                    jQuery.ajax({
                        url: '/cart/change.js',
                        method: 'POST',
                        data: {quantity: q, id: discountitem.key, properties: {"_byME": "false"}},
                        dataType: 'json',
                        success: function (result, textStatus, jqXHR)
                        {
                        },
                        error: function (jqXHR, textStatus)
                        {
                        },
                        async: false
                    });
                }
            }
        }
    }
}

/**
 *
 * @param cartItems
 * @return {number}
 */
function getGutscheinPriceInCart(cartItems)
{
    let gutscheinprice = 0;

    jQuery.each(cartItems, function (cidx, cartitem)
    {
        if (parseInt(cartitem['product_id']) === DISCOUNT_GUTSCHEIN_PRODUCT_ID)
        {
            gutscheinprice += parseFloat(cartitem['final_line_price']) / 100;
        }
    });

    return gutscheinprice;
}

/**
 *
 * @param cartItems
 * @return {number}
 */
function getPfandKostenInCart(cartItems)
{
    if (
        typeof PFAND_KOSTEN_ARTIKEL_25 !== "undefined" && !MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25) &&
        typeof PFAND_KOSTEN_ARTIKEL_25.id !== "undefined" && !MeMisc.empty(PFAND_KOSTEN_ARTIKEL_25.id)
    )
    {
        let pfandprice = 0;

        jQuery.each(cartItems, function (cidx, cartitem)
        {
            if (parseInt(cartitem['product_id']) === PFAND_KOSTEN_ARTIKEL_25.id)
            {
                pfandprice += parseFloat(cartitem['final_line_price']) / 100;
            }
        });

        return pfandprice;
    }
    else
    {
        return 0;
    }
}

/**
 *
 * @param cartItems
 * @returns object | null
 */
function getDiscountitemInCart(cartItems)
{
    if (jQuery.isArray(cartItems) === false)
        return null;

    let mycartitem = null;
    jQuery.each(cartItems, function (cidx, cartitem)
    {
        if (parseInt(cartitem['variant_id']) === DISCOUNT_VARIANT_ID)
        {
            mycartitem = cartitem;
            mycartitem.line = cidx;
        }
    });

    return mycartitem;
}

/**
 * reloadWindow
 */
function reloadWindow()
{
    window.location.reload(true);
}

/**
 * Checkbox darf nur einmal ausgewählt werden
 * @param id
 */
function inputValueChange(id)
{
    myProductId = id;
}

/**
 * Wird nur von Produkten mit Varianten ausgeführt
 * @param id
 */
function setVariantsID(id)
{
    hasVariants = true;
    currentVariantID = id;
}

/**
 * @param productID
 */
function variantChange(productID)
{
    let newVariant;
    let newVariantID = jQuery('#bonusSelect-' + productID).val();

    for (let item of free_bonus_item_products)
    {
        if (parseInt(item.id) === parseInt(productID))
        {
            for (let variant of item.variants)
            {
                if (parseInt(variant.id) === parseInt(newVariantID))
                {
                    newVariant = variant;
                    break;
                }
            }
            break;
        }
    }

    jQuery('#image-' + productID).attr('src', newVariant.featured_image.src);
}


/**
 * Wenn der Bonus-Artikel ausgewählt wurde
 */
function saveBonusItem()
{
    let additem = false;
    let variantID = null;

    if (hasVariants === true)
    {
        variantID = jQuery('#bonusSelect-' + currentVariantID).val();
    }
    else
    {
        variantID = myProductId;
    }

    if (variantID !== null)
    {
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: false,
            data: {
                items: [{
                    quantity: 1,
                    id: variantID
                }]
            },
            dataType: 'json',
            success: function (newcartitem)
            {
                window.location.href = "/cart";
            },
            error: function (data)
            {
                window.location.href = "/?error=25&msg=bonusartikel";
            }
        });
    }
    else
    {
        // error
    }
}

/**
 * Liste der Kunstwerke eines KÃ¼stlers ausgeben
 * URL: /collections/gabi-haramina
 * @category: Collection
 */
function createMyAllCollections()
{
    let SA_URL = getShopifyAppURL();

    /**
     * Virtuelle Galerie setzen
     */
    //let myArtist = artistDetails[myCollectionHandle];

    /**
     * Variablen zur Ãœbersicht
     */
    let shdw_outside = 'box-shadow: 0 0 10px 5px grey;';
    let shdw_inside = 'box-shadow: inset -1px 1px 2px 2px grey;';
    let padder10 = 'padding: 10px;';
    let padder7 = 'padding: 7px;';
    let rahmen_color = 'background-color: black;';
    let inside_color = 'background-color: white;';
    let line_zero = 'line-height: 0;';

    let qcode = `
		<li class="artworks-component innerborder shadow" style="display: flex; justify-content: center; flex-basis: 15%; margin-top: 10px">
			<figure>
				<div class="text-wrapper" style="height: 250px; display: flex; align-items: center">
					<a href="/products/{handle}">
						<div class="outside_border-deko" style="{outside_border_style}">
								<div class="inside_border-deko" style="max-width:200px; max-height:200px; {inside_border_style}">
										<img class="artwork myartwork" src="{artwork_image}" alt="artwork" style="max-width:150px; max-height:150px;">
								</div>
						</div>
					</a>
				</div>
				<figcaption style="text-align: center; font-size: 20px">
					<span style="font-size: 12px">{artist}</span>
					<br>
					<span style="font-size: 18px">{kunstwerk}</span>
				 </figcaption>
			</figure>
		</li>
	`;

    // Reihenfolge der Bilder zufällig
    let sortedArtworkDetails = Object.values(artworkDetails).sort(() => Math.random() - 0.5);
    sortedArtworkDetails = sortedArtworkDetails.sort(() => Math.random() - 0.5);
    sortedArtworkDetails = sortedArtworkDetails.sort(() => Math.random() - 0.5);

    jQuery.each(sortedArtworkDetails, function (key, item)
    {
        let newqcode = qcode;

        let artist = artistDetails[item['artisthandle']];

        newqcode = newqcode.replace(/{artwork_image}/g, SA_URL + '/' + item['image']);
        newqcode = newqcode.replace(/{artist}/g, artist['name']);
        newqcode = newqcode.replace(/{kunstwerk}/g, item['name']);
        newqcode = newqcode.replace(/{handle}/g, item['handle']);

        if (item['rahmen'] === true)
        {
            if (item['schatten'] === true)
            {
                newqcode = newqcode.replace(/{outside_border_style}/g, rahmen_color + padder10 + shdw_outside + line_zero);
                newqcode = newqcode.replace(/{inside_border_style}/g, shdw_inside + inside_color + padder7);
            }
            else
            {
                newqcode = newqcode.replace(/{outside_border_style}/g, rahmen_color + padder10 + line_zero);
                newqcode = newqcode.replace(/{inside_border_style}/g, shdw_inside + inside_color + padder7);
            }
        }
        else
        {
            if (item['schatten'] === true)
            {
                newqcode = newqcode.replace(/{outside_border_style}/g, shdw_outside + line_zero);
                newqcode = newqcode.replace(/{inside_border_style}/g, '');
            }
            else
            {
                newqcode = newqcode.replace(/{outside_border_style}/g, line_zero);
                newqcode = newqcode.replace(/{inside_border_style}/g, '');
            }
        }
        jQuery('.uebersicht .uebersicht-list').append(newqcode);
    });
}

/**
 * Weiterleitung von Customized Products zum Customizer
 *
 * Entweder über Array urlredirects
 * oder mit producthandle wie produkt_farbe_künstler_kunstwerk
 * Bsp: t-shirt_schwarz_oliver-feistmantl_abstract1
 *
 * @param producturl
 */
function doUrlRedirect(producturl)
{
    let regex = null;
    let myto = "";
    producturl = producturl.toString();
    jQuery.each(urlredirects, function (idx, item)
    {
        regex = new RegExp(item['from'], 'i');
        if (regex.test(producturl))
        {
            myto = item['to'];
        }
    });

    if (!MeMisc.empty(myto))
    {
        window.location.href = myto;
    }
    else
    {
        let parameters = producturl.split("_");
        window.location.href = parameters[0] + "?color=" + parameters[1] + "&artwork=" + parameters[2] + "_" + parameters[3];
    }
}

/**
 * Gibt die URL der Shopify-App (Test- oder Live-System) anhand der aktuell aufgerufenen URL zurück
 * (crunchysnacks.de > https://shopify-app-crunchysnacks.pco-group.com, pco-test-crunchysnacks.myshopify.com > https://dev-shopify-app-crunchysnacks.pco-group.com)
 */
function getShopifyAppURL()
{
    if ((typeof meGlobals['LIVESYSTEM'] === 'undefined') || (typeof meGlobals['LIVESYSTEM']['CHECKURL'] === 'undefined'))
        return "https://dev-shopify-app-crunchysnacks.pco-group.com";

    let regex = new RegExp('' + meGlobals['LIVESYSTEM']['CHECKURL'] + '', 'i');
    let myTest = regex.test(window.location.hostname);
    //let myMatch = regex.exec(window.location.hostname);

    if (myTest === true)
    {
        return meGlobals['LIVESYSTEM']['SYSTEMURL'];
    }
    else
    {
        return meGlobals['TESTSYSTEM']['SYSTEMURL'];
    }
}

/**
 * Gibt die Künstler aus dem artworkDetails-Array zurück
 */
function getArtists()
{
    let artists = {};
    jQuery.each(artworkDetails, function (key, item)
    {
        artists[item['artist']] = item['artist'];
    });

    return artists;
}

/**
 * https://stackoverflow.com/questions/27188246/resizing-images-to-display-in-html5-canvas
 */
function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight)
{
    let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    let rtnWidth = srcWidth * ratio;
    let rtnHeight = srcHeight * ratio;
    return {
        width: rtnWidth,
        height: rtnHeight
    };
}

/**
 * https://gist.github.com/casamia918/a8daf164830bce1b6281e304ed1f91b0
 * @param url
 * @returns {Promise}
 */
async function loadImageFromBlob(url)
{
    return new Promise((resolve, reject) =>
    {
        window.fetch(url).then(resp => resp.blob()).then(blob =>
        {
            const urlFromBlob = window.URL.createObjectURL(blob);

            const image = new window.Image()
            image.src = urlFromBlob;
            image.crossOrigin = 'Anonymous';
            image.addEventListener('load', () =>
            {
                resolve(image);
            })
            image.addEventListener('error', reject);
        })
    })
}

/**
 * Gibt das Seitenverhältnis eines Bildes zurück (landscape oder portrait)
 * Quadrat = portrait
 */
function getImageRatio(img)
{
    if (jQuery(img).width > jQuery(img).height)
        return 'landscape';
    else
        return 'portrait';
}

/**
 * Function wird beim Ändern einer Property (Artwork, Print, Signature) aufgerufen.
 * Die Function dient zum setzen den Querystrings. Bei den Varianten macht das die Function "_updateHistoryState" in theme.js.
 */
function meCustomizerOhangeProperty()
{
    if (!history.replaceState)
        return;

    let newurl = meCustomizerUpdateQuerystring();
    window.history.replaceState({path: newurl}, '', newurl);
}

/**
 * meCustomizerOnload
 */
function meCustomizerOnload()
{
    // Dropdown der Kunstwerke bauen
    jQuery(mecustomizer_fieldselector_artwork_hidden).html('');

    let qs_artwork = '';
    let urlParams = new URLSearchParams(window.location.search);
    let at = '';
    let showaw = true;
    let artist = {};

    // Kunstwerke SELECT-Box erstellen
    jQuery.each(artworkDetails, function (idx, item)
    {
        artist = artistDetails[item['artisthandle']];
        showaw = true;

        if (myProduct.handle === 'leinwand')
        {
            if ((typeof item['producttypes'] !== 'undefined') && (typeof item['producttypes']['leinwand'] !== 'undefined') && (typeof item['producttypes']['leinwand']['active'] !== 'undefined') && item['producttypes']['leinwand']['active'] === true)
                showaw = true;
            else
                showaw = false;
        }

        if (artist['active'] === false)
            showaw = false;

        if (showaw === true)
        {
            // optgroup
            if (at !== item['artisthandle'])
                jQuery(mecustomizer_fieldselector_artwork_hidden).append('<optgroup label="' + artist['name'] + '"></optgroup>');

            // option
            jQuery(mecustomizer_fieldselector_artwork_hidden + ' optgroup[label=\'' + artist['name'] + '\']').append('<option value="' + item['handle'] + '">' + artist['name'] + ': ' + item['name'] + '</option>');

            at = item['artisthandle'];
        }
    });

    // Size aus Querystring holen und auswählen
    let myParamSize = urlParams.get('size');
    if (!MeMisc.empty(myParamSize))
    {
        let sizevorhanden = false;
        jQuery(mecustomizer_fieldselector_size + ' option').each(function (idx, item)
        {
            if (jQuery(item).val() === myParamSize)
            {
                sizevorhanden = true
            }
        });
        if (sizevorhanden === true)
        {
            jQuery(mecustomizer_fieldselector_size).val(myParamSize);
        }
    }

    // Color aus Querystring holen und auswählen
    let myParamColor = urlParams.get('color');
    if (!MeMisc.empty(myParamColor))
    {
        let colorvorhanden = false;
        jQuery(mecustomizer_fieldselector_color + ' option').each(function (idx, item)
        {
            if (jQuery(item).val() === myParamColor)
            {
                colorvorhanden = true
            }
        });
        if (colorvorhanden === true)
        {
            jQuery(mecustomizer_fieldselector_color).val(myParamColor);
        }
    }

    // Kunstwerk aus Querystring holen und auswählen
    let myParamAW = urlParams.get('artwork');
    if (!MeMisc.empty(myParamAW))
        qs_artwork = myParamAW;

    // Artwork-Select anhand des Querystring-Artworks setzen
    if (!MeMisc.empty(qs_artwork))
    {
        let awvorhanden = false;
        jQuery(mecustomizer_fieldselector_artwork_hidden + ' option').each(function (idx, item)
        {
            if (jQuery(item).val() === qs_artwork)
            {
                awvorhanden = true
            }
        });
        if (awvorhanden === true)
        {
            jQuery(mecustomizer_fieldselector_artwork_hidden).val(qs_artwork);
        }
    }

    // Kunstwerk aus Querystring holen und auswählen
    let myParamPrint = urlParams.get('print');
    if (!MeMisc.empty(myParamPrint))
    {
        let printvorhanden = false;
        jQuery(mecustomizer_fieldselector_print + ' option').each(function (idx, item)
        {
            if (jQuery(item).val() === myParamPrint)
            {
                printvorhanden = true
            }
        });
        if (printvorhanden === true)
        {
            jQuery(mecustomizer_fieldselector_print).val(myParamPrint);
        }
    }

    // Bei Leinwand Select-Bedrucken ausblenden
    if (myProduct.handle === 'leinwand')
        jQuery('#selector_bedrucken').hide();

    // Formfields
    meCustomizerChangeFormFields();

    // Size: Change-Event triggern
    let sortBySelect = document.querySelector(mecustomizer_fieldselector_size);
    sortBySelect.dispatchEvent(new Event("change"));
}

/**
 * Formfields laden, Produktbild generieren
 * @category: customizer
 */
function meCustomizerChangeFormFields()
{
    // Diverse Vars
    let myProductDetail = null;
    let myArtworkDetail = null;
    let myArtistDetail = null;
    let mySignatureDetail = null;

    let fieldSize = jQuery(mecustomizer_fieldselector_size);
    let fieldColor = jQuery(mecustomizer_fieldselector_color);
    let fieldArtwork = jQuery(mecustomizer_fieldselector_artwork_hidden);
    let fieldPrint = jQuery(mecustomizer_fieldselector_print);

    let fieldSizeValue = jQuery(fieldSize).val();
    let fieldColorValue = jQuery(fieldColor).val();
    let fieldArtworkValue = jQuery(fieldArtwork).val();
    let fieldPrintValue = jQuery(fieldPrint).val();

    // Produkt suchen
    myProductDetail = productDetails[myProduct['handle']];

    // Artwork suchen
    myArtworkDetail = artworkDetails[fieldArtworkValue];

    // Unterschrift suchen
    mySignatureDetail = signatureDetails[myArtworkDetail['signature']['artisthandle']];

    // Artwork-Property setzen (Hidden-Input)
    myArtistDetail = artistDetails[myArtworkDetail['artisthandle']];
    jQuery(mecustomizer_fieldselector_artwork).val(myArtistDetail['name'] + ': ' + myArtworkDetail['name']);

    // Product im Select selektieren
    jQuery(mecustomizer_fieldselector_product).val(myProduct['handle']);

    // Breadcrumbs anpassen
    adjustBreadcrumbs(myArtistDetail);

    // SELECT-Box: Leinwand-Größen abhängig von Kunstwerk
    if (myProduct.handle === 'leinwand')
    {
        let selected = '';
        jQuery(mecustomizer_fieldselector_size + ' option').remove();
        jQuery.each(myArtworkDetail['producttypes']['leinwand']['sizes'], function (ptkey, ptitem)
        {
            jQuery.each(myProductDetail['sizes'][ptkey]['realformat'], function (rfkey, rfitem)
            {
                selected = '';
                if (rfitem === fieldSizeValue)
                    selected = " selected='selected'";

                jQuery(mecustomizer_fieldselector_size).append('<option value="' + rfitem + '"' + selected + '>' + rfitem + '</option>')
            });
        });

        // Size-Value holen
        fieldSize = jQuery(mecustomizer_fieldselector_size);
        fieldSizeValue = jQuery(fieldSize).val();
    }

    // Color-Values die in Json verwendet werden holen
    let fieldColorForJson = getColorJsonValueByFormValue(fieldColorValue);
    jQuery('#me_color_json_property').val(fieldColorForJson);
    jQuery('#me_color_property').val(fieldColorValue);

    // Size-Value die in Json verwendet werden holen
    let fieldSizeForJson = getSizeJsonValueByFormValue(fieldSizeValue);
    jQuery('#me_size_json_property').val(fieldSizeForJson);
    jQuery('#me_size_property').val(fieldSizeValue);

    // Side-Values die in Json verwendet werden holen
    let fieldPrintForJson = getPrintJsonValueByFormValue(fieldPrintValue);

    // Print-Property setzen (Hidden-Input)
    jQuery(mecustomizer_fieldselector_print_hidden).val(fieldPrintForJson);

    // Canvas malen / Bild ereugen
    meCustomizerPaintCanvas({
        'canvasId': mecustomizer_canvas,
        'color': fieldColorForJson,
        'print': fieldPrintForJson,
        'size': fieldSizeForJson,
        'myProductDetail': myProductDetail,
        'myArtworkDetail': myArtworkDetail,
        'mySignatureDetail': mySignatureDetail,
        'produktbildcontainer_selector': mecustomizer_produktbildcontainer_selector
    });

    // Social-Buttons & OG-Tags
    //changeSocial();
}

/**
 * Einfache Variante um das Bild zu erstellen (z.B. für Warenkorb)
 *
 * @param options
 * ```
 * {
 *   'canvasId' : 'meCustomizer1MyCanvas1',   : ID des versteckten Canvas
 *   'produktbildcontainer_selector' : '...', : Container in dem das Bild erstellt werden soll
 *   'color'    : 'weiß',                     : Werte aus dem Customizer (weiß wird in white umgewandelt, damit es im Json-Array gefunden wird)
 *   'print'    : 'Vorderseite',              : Werte aus dem Customizer (Vorderseite wird in front umgewandelt, damit es im Json-Array gefunden wird)
 *   'size'     : '90x60',                    : nur für Leinwände (Größe wird umgewandelt (90x60 -> 3x2), damit es im Json-Array gefunden wird)
 *   'product'  : 'hoodie',                   : Key des Produkts (Json-Array)
 *   'artwork'  : 'kiki_blah-blah'            : Key des Kunstwerks (Json-Array)
 * }
 * ```
 *
 * @example
 * ```
 <canvas id="meCustomizer1MyCanvas2" style="visibility: hidden; position: absolute; z-index: -11111111;"></canvas>
 <div id="myProduktbildcontainer2"></div>

 <script>
 meCustomizerEasyImageCreate({
 'canvasId': 'meCustomizer1MyCanvas2',
 'produktbildcontainer_selector': '#myProduktbildcontainer2',
 'color': 'weiß',
 'print': 'Vorderseite',
 'size': '90x60',
 'product': 'hoodie-1',
 'artwork': 'kiki_blah-blah'
 });
 </script>
 * ```
 */
function meCustomizerEasyImageCreate(options)
{
    let myProductDetail = productDetails[options['product']];
    let myArtworkDetail = artworkDetails[options['artwork']];
    let mySignatureDetail = signatureDetails[myArtworkDetail['artisthandle']];

    // Side-Values die in Json verwendet werden holen
    let fieldPrintForJson = options['print'];

    // Color-Values die in Json verwendet werden holen
    let fieldColorForJson = getColorJsonValueByFormValue(options['color']);

    // Size-Value die in Json verwendet werden holen
    let fieldSizeForJson = getSizeJsonValueByFormValue(options['size']);

    meCustomizerPaintCanvas({
        'canvasId': options['canvasId'],
        'color': fieldColorForJson,
        'print': fieldPrintForJson,
        'size': fieldSizeForJson,
        'myProductDetail': myProductDetail,
        'myArtworkDetail': myArtworkDetail,
        'mySignatureDetail': mySignatureDetail,
        'produktbildcontainer_selector': options['produktbildcontainer_selector']
    });
}

/**
 * Canvas mit Produktbild, Kunstwerk und Unterschrift wird erstellt, daraus wird ein Bild erstellt und entsprechend platziert.
 * Canvas und Produktbildcontainer muss vorhanden sein.
 *
 * @param {Object} options
 * ```
 * {
 *   'canvasId' : 'meCustomizer1MyCanvas1',
 *   'color'    : 'white',
 *   'print'    : 'front',
 *   'size'     : '3x4', : Für Leinwände
 *   'myProductDetail' : Array-Eintrag aus productDetails,
 *   'myArtworkDetail' : Array-Eintrag aus artworkDetails,
 *   'mySignatureDetail' : Array-Eintrag aus signatureDetails,
 *   'produktbildcontainer_selector' : Container in dem das Bild erstellt werden soll
 * }
 * ```
 */
function meCustomizerPaintCanvas(options)
{
    let p_color = '';
    let p_print = '';
    let p_size = '';
    let myProductDetail = {};
    let myArtworkDetail = {};
    let produktbildcontainer_selector = '';
    let SA_URL = getShopifyAppURL();

    if (!MeMisc.empty(options['color']))
        p_color = options['color'];
    if (!MeMisc.empty(options['print']))
        p_print = options['print'];
    if (!MeMisc.empty(options['size']))
        p_size = options['size'];
    if (!MeMisc.empty(options['myProductDetail']))
        myProductDetail = options['myProductDetail'];
    if (!MeMisc.empty(options['myArtworkDetail']))
        myArtworkDetail = options['myArtworkDetail'];
    if (!MeMisc.empty(options['produktbildcontainer_selector']))
        produktbildcontainer_selector = options['produktbildcontainer_selector'];

    // ProduktBildContainer: Inhalt entfernen
    jQuery(produktbildcontainer_selector).html('');
    jQuery(produktbildcontainer_selector).append('<img id="ajax_loader" src="' + ajax_loader_gif + '" style="width:30px;height:30px;position: absolute;left:50%;top:50%;" alt="ajax_loader" />');

    currentProductImage = SA_URL + "/me/product/getimage.php?product=" + myProductDetail['handle'] + "&color=" + p_color + "&print=" + p_print + "&size=" + p_size + "&artwork=" + myArtworkDetail['handle'];

    let ret1 = loadImageFromBlob(currentProductImage);
    ret1.then(
        function (image)
        {
            if (typeof image === "object" && image instanceof Node)
            {
                image.width = 430;
                jQuery(produktbildcontainer_selector).append(image);
            }
            else
            {
                jQuery(produktbildcontainer_selector).append('Das Produkt-Bild kann aktuell leider nicht erzeugt werden.');
            }

            // Loader entfernen
            jQuery(produktbildcontainer_selector + ' #ajax_loader').remove();
        }
    );
}

/**
 * Varianten-ID und Properties in Querystring
 */
function meCustomizerUpdateQuerystring()
{
    let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    let fieldSize = jQuery(mecustomizer_fieldselector_size).val();
    let fieldColor = jQuery(mecustomizer_fieldselector_color).val();
    let fieldArtwork = jQuery(mecustomizer_fieldselector_artwork_hidden).val();
    let fieldPrint = jQuery(mecustomizer_fieldselector_print).val();
    //let fieldSignature = jQuery('.product-form__controls-group #unterschrift').val();
    newurl = newurl + "?size=" + fieldSize + "&color=" + fieldColor + "&artwork=" + fieldArtwork + "&print=" + fieldPrint

    return newurl;
}

/**
 * Side-Values die in Json verwendet werden holen
 */
function getPrintJsonValueByFormValue(fieldPrintValue)
{
    // Side-Values die in Json verwendet werden holen
    let fieldPrintForJson = '';
    if (fieldPrintValue === 'Rueckseite')
        fieldPrintForJson = 'back';
    else
        fieldPrintForJson = 'front';

    return fieldPrintForJson;
}

/**
 * Color-Values die in Json verwendet werden holen
 */
function getColorJsonValueByFormValue(fieldColorValue)
{
    // Color-Values die in Json verwendet werden holen
    let fieldColorForJson = '';
    if (fieldColorValue === 'schwarz')
        fieldColorForJson = 'black';
    else if (fieldColorValue === 'grau')
        fieldColorForJson = 'grey';
    else
        fieldColorForJson = 'white';

    return fieldColorForJson;
}

/**
 * Size-Value die in Json verwendet werden holen
 */
function getSizeJsonValueByFormValue(fieldSizeValue)
{
    let fieldSizeForJson = '';

    // Leinwand
    if (fieldSizeValue === '40x60 cm' || fieldSizeValue === '60x90 cm')
        fieldSizeForJson = '2x3';
    if (fieldSizeValue === '60x40 cm' || fieldSizeValue === '90x60 cm')
        fieldSizeForJson = '3x2';
    if (fieldSizeValue === '90x120 cm')
        fieldSizeForJson = '3x4';
    if (fieldSizeValue === '120x90 cm')
        fieldSizeForJson = '4x3';
    if (fieldSizeValue === '100x120 cm')
        fieldSizeForJson = '5x6';
    if (fieldSizeValue === '120x100 cm')
        fieldSizeForJson = '6x5';
    if (fieldSizeValue === '60x60 cm' || fieldSizeValue === '100x100 cm')
        fieldSizeForJson = '1x1';

    // Tasche
    if (fieldSizeValue === '59x39x20 cm')
        fieldSizeForJson = '59x39x20';
    if (fieldSizeValue === '49x39x15 cm')
        fieldSizeForJson = '49x39x15';

    if (MeMisc.empty(fieldSizeForJson))
        fieldSizeForJson = '1x1';

    return fieldSizeForJson;
}

/**
 * Künstler + Mainimage in .myStartCollectionList ausgeben
 * URL: / (Startseite)
 * @category: index
 */
function createCollectionList()
{
    let SA_URL = getShopifyAppURL();
    let qcode = `
        <li class="grid__item small--one-half medium-up--one-third">
          <div class="collection-grid-item">
            <a href="/collections/{artist_handle}" class="collection-grid-item__link">

              <div class="collection-grid-item__overlay box ratio-container js lazyloaded" data-bgset="{artist_mainimage}" data-parent-fit="cover" alt="" src="" style="background-image: url('{artist_mainimage}');">
                <picture style="display: none;">
                  <source data-srcset="{artist_mainimage}">
                  <img alt="" class="lazyautosizes lazyloaded ls-is-cached" data-sizes="auto" data-parent-fit="cover" sizes="457.3333333333333px">
                </picture>
              </div>
              <noscript>
                <div class="collection-grid-item__overlay" style="background-image: url('{artist_mainimage}')"></div>
              </noscript>

              <div class="collection-grid-item__title-wrapper">
                <div class="collection-grid-item__title h3">
                  {artist_name}
                </div>
              </div>
            </a>
          </div>
        </li>
    `;

    // Reihenfolge der Bilder zufällig
    let sortedArtistDetails = Object.values(artistDetails).sort(() => Math.random() - 0.5);
    sortedArtistDetails = sortedArtistDetails.sort(() => Math.random() - 0.5);
    sortedArtistDetails = sortedArtistDetails.sort(() => Math.random() - 0.5);

    jQuery.each(sortedArtistDetails, function (key, item)
    {
        if (item['active'] === true)
        {
            let newqcode = qcode.replace(/{artist_handle}/g, item['handle']);
            newqcode = newqcode.replace(/{artist_mainimage}/g, SA_URL + '/' + item['mainimage']);
            newqcode = newqcode.replace(/{artist_name}/g, item['name']);

            jQuery('.myStartCollectionList').append(newqcode);
        }
    });
}

/**
 * Liste der Kunstwerke eines Küstlers ausgeben
 * URL: /collections/gabi-haramina
 * @category: Collection
 */
function createMyCollection(addArtistInfo = false)
{
    let SA_URL = getShopifyAppURL();

    /**
     * Virtuelle Galerie setzen
     */
    let myArtist = artistDetails[myCollectionHandle];
    jQuery('.virtual-tour-container #virtual-tour-iframe').attr('src', SA_URL + '/' + myArtist['virtual_gallery_link']);

    /**
     * Variablen zur Übersicht
     */
    let shdw_outside = 'box-shadow: 0 0 10px 5px grey;';
    let shdw_inside = 'box-shadow: inset -1px 1px 2px 2px grey;';
    let padder10 = 'padding: 10px;';
    let padder7 = 'padding: 7px;';
    let rahmen_color = 'background-color: black;';
    let inside_color = 'background-color: white;';
    let line_zero = 'line-height: 0;';

    let qcode = `
        <li class="artworks-component innerborder shadow" style="display: flex; justify-content: center; flex-basis: 33%; margin-top: 50px">
            <figure>
                <div class="text-wrapper" style="height: 500px; display: flex; align-items: center">
                    <a href="/products/{handle}">
                        <div class="outside_border-deko" style="{outside_border_style} {size}">
                            <div class="inside_border-deko" style="{inside_border_style}">
                                <img class="artwork myartwork" src="{artwork_image}" style="max-width:400px;max-height:400px; margin: 0 auto;" alt="artwork">
                            </div>
                        </div>
                    </a>
                </div>
                <figcaption style="text-align: center; font-size: 20px"> <b> {artwork_titel} </b> </figcaption>
            </figure>
        </li>
    `;
    if (addArtistInfo === true)
    {
        jQuery('.artworks-new .artworks-grid').append(`
			<li style="display: flex; justify-content: center; flex-basis: 33%; margin-top: 50px">
				<div class="text-wrapper" style="height: 500px; display: flex; align-items: center">
					<div style="max-width: 400px" onclick="toggleModal('artistModal')" class="memodal-click">
						<img src="` + artistImgUrl + `" alt="" style="max-height:50%;width:100%;object-fit: cover;margin-top:20%;min-width:300px">
						<h3 class="artist-title"  style="text-align: center;">
							` + myArtist.name + `
						</h3>
						<div class="more-info" style="margin-top:30%">
							Für weitere Informationen über ` + myArtist.name + ` bitte hier klicken.
						</div>
					</div>
				</div>
			</li>
		`);

        jQuery('body').append(`
		<div id="artistModal" class="memodal" >
			<div class="memodal-content">
				<span class="close" onclick="toggleModal('artistModal')">&times;</span>
				<div class="memodal-banner" style="width: 100%;text-align: center"><img src="` + artistImgUrl + `" alt="" style="object-fit: cover;">
				</div>
				<div style="max-width:75%;margin: auto">
					<div class="memodal-title">
						<h1>
						` + myArtist.name + `
						</h1>
					</div>
						<div class="memodal-text" style="">
						<p>
						` + artistDesc + `
						</p>
					</div>
				</div>
			</div>
		</div>
		`);
    }

    // Reihenfolge der Bilder zufällig
    let sortedArtworkDetails = Object.values(artworkDetails).sort(() => Math.random() - 0.5);
    sortedArtworkDetails = sortedArtworkDetails.sort(() => Math.random() - 0.5);
    sortedArtworkDetails = sortedArtworkDetails.sort(() => Math.random() - 0.5);

    jQuery.each(sortedArtworkDetails, function (key, item)
    {
        if (item['artisthandle'] === myCollectionHandle)
        {
            let newqcode = qcode;

            newqcode = newqcode.replace(/{artwork_image}/g, SA_URL + '/' + item['image']);
            newqcode = newqcode.replace(/{artwork_titel}/g, item['name']);
            newqcode = newqcode.replace(/{handle}/g, item['handle']);

            if (item['rahmen'] === true)
            {
                if (item['schatten'] === true)
                {
                    newqcode = newqcode.replace(/{outside_border_style}/g, rahmen_color + padder10 + shdw_outside + line_zero);
                    newqcode = newqcode.replace(/{inside_border_style}/g, shdw_inside + inside_color + padder7);
                }
                else
                {
                    newqcode = newqcode.replace(/{outside_border_style}/g, rahmen_color + padder10 + line_zero);
                    newqcode = newqcode.replace(/{inside_border_style}/g, shdw_inside + inside_color + padder7);
                }
            }
            else
            {
                if (item['schatten'] === true)
                {
                    newqcode = newqcode.replace(/{outside_border_style}/g, shdw_outside + line_zero);
                    newqcode = newqcode.replace(/{inside_border_style}/g, '');
                }
                else
                {
                    newqcode = newqcode.replace(/{outside_border_style}/g, line_zero);
                    newqcode = newqcode.replace(/{inside_border_style}/g, '');
                }
            }
            jQuery('.artworks-new .artworks-grid').append(newqcode);
        }
    });
}

/**
 *
 * @param modalID
 */
function toggleModal(modalID)
{
    let modal = jQuery("#" + modalID)

    if (modal.hasClass("shown"))
    {
        modal.hide();
        modal.removeClass("shown");
    }
    else
    {
        modal.show();
        modal.addClass("shown");
    }
}

/**
 * Virtuelle Galerie sperren/freischalten
 * @category: Collection
 */
function toggleTour()
{
    let iframe = jQuery(".virtual-tour-iframe");
    let overlay = jQuery(".virtual-tour-overlay");
    let exitbutton = jQuery(".exit-tour");

    if (iframe.hasClass("active"))
    {
        overlay.show();
        iframe.css('pointer-events', 'none');
        exitbutton.hide();
        iframe.removeClass("active");
    }
    else
    {
        overlay.hide();
        iframe.css('pointer-events', '');
        exitbutton.show();
        iframe.addClass("active");
    }
}

/**
 *
 */
function displayLeinwand()
{
    let SA_URL = getShopifyAppURL();

    /**
     * Variablen zur Übersicht
     */
    let shdw_outside = 'box-shadow: 0 0 10px 5px grey;';
    let padder3 = 'padding: 3px;';
    let inside_color = 'background-color: white;';
    let line_zero = 'line-height: 0;';

    let leinw = `
        <li class="leinwand-component innerborder shadow" style="display: flex; justify-content: center; flex-basis: 33%; margin-top: 50px">
            <figure>
                <div class="text-wrapper" style="height: 500px; display: flex; align-items: center">
                    <a href="/products/leinwand?artwork={handle}">
                        <div class="outside_border-deko" style="{outside_border_style}">
                            <div class="inside_border-deko" style="">
                                <img class="leinwand-artwork" src="{leinwand-bild}" style="max-width:400px;max-height:400px;" alt="leinwand">
                            </div>
                        </div>
                    </a>
                </div>
                <figcaption style="text-align: center;">
                 <span style="font-size: 14px">{artist}</span>
								 <br>
								 <span style="font-size: 20px">{artwork_titel}</span>
                </figcaption>
            </figure>
        </li>
    `;

    jQuery.each(artworkDetails, function (key, art)
    {
        if
        (
            (typeof (art['producttypes']) !== 'undefined') &&
            (typeof (art['producttypes']['leinwand']) !== 'undefined') &&
            (typeof (art['producttypes']['leinwand']['sizes']) !== 'undefined') &&
            (!MeMisc.empty(art['producttypes']['leinwand']['sizes']))
        )
        {
            let i = 0;
            jQuery.each(art['producttypes']['leinwand']['sizes'], function (skey, sitem)
            {
                i++;
            });

            let rani = Math.floor(Math.random() * i) + 1;
            let titem;
            i = 0;
            jQuery.each(art['producttypes']['leinwand']['sizes'], function (skey, sitem)
            {
                i++;
                if (i === rani)
                {
                    titem = sitem;
                }
            });

            let image = SA_URL + '/' + titem['image'];

            let mem = leinw.replace(/{leinwand-bild}/g, image);
            mem = mem.replace(/{artwork_titel}/g, art['name']);
            mem = mem.replace(/{artist}/g, artistDetails[art['artisthandle']]['name']);
            mem = mem.replace(/{handle}/g, art['handle']);
            mem = mem.replace(/{outside_border_style}/g, shdw_outside + inside_color + line_zero + padder3);

            jQuery('.all-customized-leinwand .customized-content-leinwand').append(mem);
        }
    });
}

/**
 * Social-Buttons & OG-Tags anpassen
 */

/*
function changeSocial()
{
    let urler = location.href;
    let link_pin = '//pinterest.com/pin/create/button/?url=' + encodeURIComponent(urler) + '&media=' + encodeURIComponent(currentProductImage) + '&description={{ share_title | url_param_escape }}';
    let link_twi = '//twitter.com/share?text=&url=' + encodeURIComponent(urler);
    let link_fac = '//www.facebook.com/sharer.php?u=' + encodeURIComponent(urler);

    jQuery('.share-pinterest').attr('href', link_pin);
    jQuery('.share-twitter').attr('href', link_twi);
    jQuery('.share-facebook').attr('href', link_fac);

    // OG-Tags
    jQuery('#og-image').attr('content', currentProductImage);
    jQuery('#og-ns-image').attr('content', currentProductImage);
}*/

/**
 * Von Inkybay wird im Warenkkorb auf den Artikel pointerevents auf none gesetzt.
 * Diese Funktion soll die PointerEvents wieder zulassen.
 * Funktion ruft sich im sekunden-rhythmus selbst auf.
 */
function deleteCartProductPointerEvent()
{
    jQuery('#cart-table .cart-table > div.item div.three span.quantity').each(function (cidx, item)
    {
        if (jQuery(item).css('pointer-events') === 'none')
        {
            jQuery(item).css('pointer-events', 'auto');
        }
    });

    setTimeout(function ()
    {
        deleteCartProductPointerEvent();
    }, 1000);
}

/**
 *
 */
function checkHeader()
{
    if (jQuery(this).scrollTop() < 75)
    {
        //Logo
        jQuery('header .header-toolbar .img-align').show();
        //Shop-Titel
        jQuery('header .header-toolbar .shop-title').hide();

        jQuery('header .sticky-navigation .header-navigation .logo').css('height', '106px');
    }
    else if (jQuery(this).scrollTop() > 300)
    {
        //Logo
        jQuery('header .header-toolbar .img-align').hide();
        //Shop-Titel
        jQuery('header .header-toolbar .shop-title').show();

        jQuery('header .sticky-navigation .header-navigation .logo').css('height', '40px');
    }
}

/**
 * Fügt ein Breadcrumb zur Collection des aktuellen Kunstwerkes hinzu
 * @param myArtistDetail
 */
function adjustBreadcrumbs(myArtistDetail)
{
    let current_link = '';

    if (typeof (myArtistDetail['handle'] !== 'undefined') && typeof (myArtistDetail['name'] !== 'undefined'))
    {
        current_link = '/collections/' + myArtistDetail['handle'];
        jQuery('.link-to-collection-before').attr('href', current_link);
        jQuery('.link-to-collection-before').append(myArtistDetail['name']);
    }
}

/**
 *
 * @param menu
 */
function hideGutscheinBadge(menu)
{
    setTimeout(function ()
    {
        if (jQuery(menu).hasClass('active'))
        {
            jQuery('.gutschein-badge').hide();
        }
        else
        {
            jQuery('.gutschein-badge').show();
        }
    }, 300);
}

/**
 *
 * @param menu
 */
function hideBaenderBadge(menu)
{
    setTimeout(function ()
    {
        if (jQuery(menu).hasClass('active'))
        {
            jQuery('.baenderbadge').hide();
        }
        else
        {
            jQuery('.baenderbadge').show();
        }
    }, 300);
}

/**
 * Holt sich den Warenkorb über Ajax und ersetzt den aktuellen damit
 */
function ajaxLoadCart()
{
    $('#ajaxBusy').show();

    jQuery.ajax({
        type: 'GET',
        url: '/cart',
        data: {},
        async: false,
        complete: function (data)
        {
            jQuery('#cart-dropdown-span').html(jQuery('#cart-dropdown-span', data.responseText).html());
            jQuery('.discount-cart').html(jQuery('.discount-cart', data.responseText).html());
            jQuery('.cart-table').html(jQuery('.cart-table', data.responseText).html());
            jQuery('#total-cart-bottom').html(jQuery('#total-cart-bottom', data.responseText).html());
            jQuery('#total-cart-top').html(jQuery('#total-cart-top', data.responseText).html());

            $('#ajaxBusy').hide();
        }
    });
}
